/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';
//current Quarter
const currentDate = new Date();
const currentMonth = currentDate.getMonth() + 1; // Month is zero-indexed, so add 1
const currentYear = currentDate.getFullYear();
const currentQuarter = Math.ceil(currentMonth / 3); // Divide the current month by 3 and round up to get the current quarter

const formattedQuarter = currentQuarter + 'Q' + currentYear.toString();
const initialState = {
  performDisputeResolutionObj: {},
  planType: [],
  rebateProgram: [],
  errorMsgRosi: [],
  drugData: [],
  rebateProgramName: {},
  selectedValue: 'Manufacturer',
  quarterFrom: formattedQuarter,
  selectedSearchType: 'Name',

  selectedPlanType: '',
  selectedNDC: [],
  ndcLeftTableData: [],
  labelerSelectedRow: [],
  selectRowIndex: null,
  gridPQAS: [],
  gridROSI: [],
  allManufacturer: [],
  manufactureWithIds: [],
  manufacturerList: [],
  displayObj: {
    quarterFrom: formattedQuarter,
    selectedValue: 'Manufacturer',
    recapGrid: [],
    rebateProgramName: {},
    gridPQAS: [],
    gridROSI: [],
    allManufacturer: [],
    manufactureWithIds: [],
    labelerTableData: [],
    selectedNDC: [],
    ndcLeftTableData: [],
    labelerSelectedRow: [],
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ_ROSI:
      return { ...state, performRosiResolutionObj: action.screenData };

    case actionTypes.GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_ROSI:
      return { ...state, RosiResolutionDetailObj: action.detailScrData };

    case actionTypes.GET_ERROR_MSG_ROSI:
      return { ...state, errorMsgRosi: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_ROSI:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_ROSI:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_ROSI:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.MANUFACTURER_GRID_ROSI:
      return { ...state, manufacturerList: action.manufacturerList };

    case actionTypes.GET_ALL_LABELER_ROSI:
      return { ...state, labelerList: action.payload };

    case actionTypes.GET_MANUFACTURER_NAME_ROSI:
      return { ...state, allManufacturer: action.allManufacturer };
    case actionTypes.GET_MANUFACTURER_ID_ROSI:
      return {
        ...state,
        manufactureWithIds: action.manufactureWithIds,
      };
    case actionTypes.GET_INDEX:
      return { ...state, ...action.payload };
    case actionTypes.GRID_MFG_ROSI:
      return { ...state, gridMFG: action.payload };
    case actionTypes.GRID_NDC_ROSI:
      return { ...state, gridNDC: action.payload };
    case actionTypes.SELECT_OPTION:
      return { ...state, selectedValue: action.payload };
    case actionTypes.GET_DRUG_DATA_ROSI:
      const ndcData = [...action.payload.selectedNDC] || [];
      // const grp = Object.groupBy(ndcData, ({ labelerCode }) => labelerCode);
      const grp = ndcData.reduce((x, y) => {(x[y.labelerCode] = x[y.labelerCode] || []).push(y);return x;}, {});
      let drugs = Object.keys(grp).map((obj) => {
        return {
          labelerCode: obj,
          drugSeqNum: grp[obj].map((val) => val.drugSeqNum),
        };
      });
      drugs = drugs.sort((a, b) => a.labelerCode - b.labelerCode);
      return {
        ...state,
        drugData: drugs,
        selectedNDC: action.payload.selectedNDC,
        ndcLeftTableData: action.payload.ndcLeftTableData,
        labelerSelectedRow: action.payload.labelerSelectedRow,
      };
    case actionTypes.SELECT_SEARCH_TYPE:
      return { ...state, ...action.payload };
    case actionTypes.GET_FROM:
      return { ...state, quarterFrom: action.payload };
    case actionTypes.GET_ROSI_GRID_DATA:
      let displayObj = {
        ...state.displayObj,
        gridROSI: action.payload,
      };
      return { ...state, gridROSI: action.payload, displayObj };
    case actionTypes.SET_DISPLAY_OBJ_ROSI:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.GET_PQAS_GRID_DATA:
      let displayObj1 = {
        ...state.displayObj,
        gridPQAS: action.payload,
      };
      return { ...state, gridPQAS: action.payload, displayObj: displayObj1 };
    // return { ...state, gridPQAS: action.payload };
    case actionTypes.SET_REFRESH_DATA_ROSI:
      return {
        ...state,
        performDisputeResolutionObj: {},
        planType: [],
        rebateProgram: [],
        errorMsgRosi: [],
        drugData: [],
        rebateProgramName: {},
        selectedValue: 'Manufacturer',
        quarterFrom: '',
        selectedSearchType: 'Name',

        selectedPlanType: '',
        selectedNDC: [],
        ndcLeftTableData: [],
        labelerSelectedRow: [],
        selectRowIndex: null,
        gridPQAS: [],
        gridROSI: [],
        allManufacturer: [],
        manufactureWithIds: [],
        manufacturerList: [],
      };
    case actionTypes.SET_REFRESH_DATA_ROSI_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    case actionTypes.SET_PAGINATION_INDEX_ROSI_PQAS:
      return {
        ...state,
        displayObj: { ...state.displayObj, countValue: action.payload },
      };
    default:
      return state;
  }
};
export default reducer;
